module.exports = __webpack_public_path__ + "img/deposit.0698156b.png";